import { useEffect, useRef, useCallback } from "react";

interface Props {
  onDismiss: () => void;
}

export default function ScreensaverOverlay({ onDismiss }: Props) {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleActivity = useCallback(() => {
    onDismiss();
  }, [onDismiss]);

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keydown", "touchstart"];
    events.forEach(e => window.addEventListener(e, handleActivity));
    videoRef.current?.play().catch(() => {});
    return () => {
      events.forEach(e => window.removeEventListener(e, handleActivity));
    };
  }, [handleActivity]);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "#000",
        cursor: "none",
      }}
      onClick={handleActivity}
    >
      <video
        ref={videoRef}
        src="/assets/screensaver.mp4"
        loop
        muted
        playsInline
        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
      />
    </div>
  );
}